import { render, staticRenderFns } from "./CurrentPlan.vue?vue&type=template&id=20849a34&scoped=true&"
import script from "./CurrentPlan.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CurrentPlan.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CurrentPlan.vue?vue&type=style&index=0&id=20849a34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20849a34",
  null
  
)

export default component.exports